function team() {
   $('.wrap-list-equipe ul li').hover(
      function (){
         $(this).find('.cite').addClass('display');
         $(this).find('.work').css('color', '#d74863');
         $(this).find('.name').css('color', '#d74863');
      }, function(){
         $(this).find('.cite').removeClass('display');
         $(this).find('.work').css('color', '#000000');
         $(this).find('.name').css('color', '#000000');
      }
   );

   $('.owl-carousel').owlCarousel({
      nav: false,
      items: 2,
      stagePadding: 0,
   });
}

module.exports = function () {
   window.addEventListener('load ready resize', team);
   team();
};
